/*
 * wtf-variant-autoselect.js (2026-09-26)
 * When a shopper picks an option value whose combination with the other
 * current selections does not exist (e.g. Style = Long Sleeve while a
 * T-Shirt-only colour is selected), move the OTHER options to the closest
 * existing variant BEFORE Dawn's <variant-selects> change handler reads the
 * selection. Dawn then fetches that real variant as normal: photo, price,
 * ?variant= and the add-to-cart id all follow.
 *
 * Rule: keep the value just clicked. For every other option, in option
 * order, keep the current value if an available variant still has it;
 * otherwise take the first value (in the option's own order) that has an
 * available variant; otherwise the first value that has any variant.
 *
 * Generic: no product, option or colour names. Data comes from the
 * <script data-wtf-variant-map> JSON that snippets/product-variant-picker
 * renders inside <variant-selects>. Does nothing when the clicked
 * combination already exists, so products where every combination exists
 * (FF tees, single-option products) behave exactly as before.
 */
(function () {
  'use strict';
  if (window.wtfVariantAutoSelect) return;
  window.wtfVariantAutoSelect = true;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function getGroups(root) {
    return toArray(root.querySelectorAll('fieldset, .product-form__input--dropdown'));
  }

  function readVariants(root) {
    var el = root.querySelector('script[data-wtf-variant-map]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function groupValues(group) {
    var select = group.querySelector('select');
    if (select) return toArray(select.options).map(function (o) { return o.value; });
    return toArray(group.querySelectorAll('input[type="radio"]')).map(function (i) { return i.value; });
  }

  function groupSelected(group) {
    var select = group.querySelector('select');
    if (select) return select.value;
    var checked = group.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function setGroup(group, value) {
    var select = group.querySelector('select');
    if (select) {
      toArray(select.options).forEach(function (o) {
        if (o.value === value) {
          o.setAttribute('selected', 'selected');
          o.selected = true;
        } else {
          o.removeAttribute('selected');
        }
      });
      return;
    }
    toArray(group.querySelectorAll('input[type="radio"]')).forEach(function (input) {
      if (input.value === value) {
        input.checked = true;
        var shown = group.querySelector('[data-selected-value]');
        if (shown && !group.querySelector('select')) shown.textContent = value;
      }
    });
  }

  function matches(variant, fixed) {
    for (var key in fixed) {
      if (Object.prototype.hasOwnProperty.call(fixed, key) && variant.o[key] !== fixed[key]) return false;
    }
    return true;
  }

  function onChange(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest('variant-selects');
    if (!root) return;

    var groups = getGroups(root);
    var k = -1;
    for (var g = 0; g < groups.length; g++) {
      if (groups[g].contains(target)) {
        k = g;
        break;
      }
    }
    if (k < 0) return;

    var variants = readVariants(root);
    if (!variants || !variants.length || !variants[0].o || variants[0].o.length !== groups.length) return;

    var current = groups.map(groupSelected);
    if (current.some(function (v) { return v === null; })) return;

    var exists = variants.some(function (v) {
      return current.every(function (value, i) { return v.o[i] === value; });
    });
    if (exists) return;

    var fixed = {};
    fixed[k] = current[k];
    var pick = current.slice();

    for (var i = 0; i < groups.length; i++) {
      if (i === k) continue;
      var pool = variants.filter(function (v) { return matches(v, fixed); });
      if (!pool.length) return;

      var has = function (value, needAvailable) {
        return pool.some(function (v) { return v.o[i] === value && (!needAvailable || v.a); });
      };
      var values = groupValues(groups[i]);
      var choice = null;

      if (has(current[i], true)) {
        choice = current[i];
      } else {
        for (var a = 0; a < values.length && choice === null; a++) {
          if (has(values[a], true)) choice = values[a];
        }
        if (choice === null && has(current[i], false)) choice = current[i];
        for (var b = 0; b < values.length && choice === null; b++) {
          if (has(values[b], false)) choice = values[b];
        }
      }
      if (choice === null) return;
      fixed[i] = choice;
      pick[i] = choice;
    }

    for (var j = 0; j < groups.length; j++) {
      if (j !== k && pick[j] !== current[j]) setGroup(groups[j], pick[j]);
    }
  }

  /* 2026-10-03 (R388 item 2): when snippets/product-variant-picker preselected the featured-photo colour, the server still
     rendered the add-to-cart form with the stock default variant id. Copy the picked variant's id into the form so a click on
     Add (or Buy now, where no size is needed) buys the colour the shopper sees. This script is deferred, so it runs before
     first paint of any interaction. Only the hidden id input changes; a later option change makes Dawn re-render as normal. */
  (function () {
    var vs = document.querySelector('variant-selects[data-wtf-target-variant]');
    if (!vs) return;
    var id = vs.getAttribute('data-wtf-target-variant');
    if (!id) return;
    toArray(document.querySelectorAll('product-form input[name="id"], form[id^="product-form-"] input[name="id"]')).forEach(function (input) {
      if (input.value !== id) input.value = id;
    });
  })();

  /* Capture phase on document: runs before the bubble-phase listener that
     <variant-selects> (assets/global.js) uses to read the selection. */
  document.addEventListener('change', onChange, true);
})();
